/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placedetailcontact2Inputs */

const en_placedetailcontact2 = /** @type {(inputs: Placedetailcontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const de_placedetailcontact2 = /** @type {(inputs: Placedetailcontact2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Placedetailcontact2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placedetailcontact2 = /** @type {((inputs?: Placedetailcontact2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placedetailcontact2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placedetailcontact2(inputs)
	return de_placedetailcontact2(inputs)
});
export { placedetailcontact2 as "placeDetailContact" }